import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store, persistor } from './services/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css';
import { ClinicCallProvider } from './components/clinic-calling/ClinicCallProvider';
import FrontendErrorBoundary from './components/error/FrontendErrorBoundary';
import installGlobalErrorReporting from './monitoring/installGlobalErrorReporting';
import installBreadcrumbs from './monitoring/installBreadcrumbs';

// Prevent Flowbite/any script from enabling dark mode: remove 'dark' class so dark: styles never apply
document.documentElement.classList.remove('dark');

// Watchdog: capture uncaught errors + promise rejections and forward them to
// the backend (/api/frontend-incidents -> #oatrx-errors). Never throws.
installGlobalErrorReporting();
// Breadcrumbs: record route changes + control clicks so an error report shows
// HOW the user got there. Labels only, never values.
installBreadcrumbs();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate persistor={persistor}>
				<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
					<FrontendErrorBoundary>
						<ClinicCallProvider>
							<App />
						</ClinicCallProvider>
					</FrontendErrorBoundary>
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</React.StrictMode>
)

